import { Plan } from "../components/shared/User/types";

export const Z_APPS_SHORT_HOST = "lingual-ninja.com";
export const Z_APPS_SHORT_URL = `https://${Z_APPS_SHORT_HOST}`;
export const Z_APPS_HOST = `www.${Z_APPS_SHORT_HOST}`;
export const Z_APPS_TOP_URL = `https://${Z_APPS_HOST}`;

export const Z_APPS_ORIGIN_HOST = `origin.${Z_APPS_SHORT_HOST}`;
export const Z_APPS_COPY_HOST = `copy.${Z_APPS_SHORT_HOST}`;

export const BLOG_URL = `https://blog.${Z_APPS_SHORT_HOST}`;

export const ARTICLES_URL = "/articles";

/**
 * 料金がかさむため、CDN利用取りやめ
 */
// const CDN_URL = "https://ninja-cdn.azureedge.net";
// export const BLOB_URL = `${CDN_URL}/lingual-storage`;

export const BLOB_URL =
    "https://lingualninja.blob.core.windows.net/lingual-storage";

export const gameStorage = `${BLOB_URL}/game/`;

export const articlesStorage = `${BLOB_URL}/articles/`;

export const appsPublicImg = `${BLOB_URL}/appsPublic/img/`;

// export const azureUrl = "japaneastzapps.azurewebsites.net";
export const azureUrl =
    "redirect-test1-amascrbvbxc3a8ba.japaneast-01.azurewebsites.net";

export const youtubeChannelUrl = "https://www.youtube.com/c/LingualNinja";
export const youtubeSubscriptionUrl =
    "http://www.youtube.com/@LingualNinja?sub_confirmation=1";

export const adminUserId = 1;
export const adminAuthorId = 1;

// サーバーサイドのMessageService.csにおける「SendMessageToAdmin」内の内容に対応（消費値の変更時は同時に両方のファイル修正が必要）
export const MESSAGE_TO_ADMIN_CHAKRA_COST_BY_PLAN = {
    [Plan.Free]: 1,
    [Plan.Chunin]: 1,
    [Plan.Jonin]: 0,
    [Plan.Hokage]: 0,
} as const;

export const AUDIO_DOWNLOAD_CHAKRA_COST = 2;
export const GENRE_UNLOCK_CHAKRA_COST = 1;
